import React, { Component } from 'react';
import PlaceHolder from './placeholder';
class LoadingPlaceholder extends Component {
    render() {
        return (
            <div className=" dip_bar m-5 p-5 w3-round">
                <PlaceHolder />
                <PlaceHolder />
                <PlaceHolder />
            </div>
        )
    }
}

export default LoadingPlaceholder;